export const versionInfo = {
  major: 1,
  minor: 2,
 git_hash: 'ebbce9e3'
};
